/**
 * group-member-avatar.js
 */

import React from 'react';
import { ListItemAvatar, Avatar } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 'auto',
    '& .MuiAvatar-root': {
      height: 36,
      width: 36,
      fontSize: theme.typography.sizes[4],
    },
  },
}));


export default function GroupMemberAvatar(props) {
  const {
    name,
    initials: initialsProp, 
  } = props;
  const classes = useStyles();
  const nameParts = name?.split(' ');
  const initials = initialsProp !== undefined
    ? initialsProp
    : `${nameParts?.[0]?.[0] || ''}${nameParts[nameParts.length-1]?.[0]?.[0] || ''}`.toUpperCase();


  return (      
    <ListItemAvatar className={classes.root}>
      <Avatar>{initials}</Avatar>
    </ListItemAvatar>
  );
}